import React from "react";
import { useHistory, useParams } from "react-router-dom";
import { useGroup } from "../../api/useQueries";
import { LegacyLoader } from "../../../../../../components/Loader/Loader";
import StudentCollectionDetails from "../../../../../../components/StudentCollectionDetails/StudentCollectionDetails";
import PageWrapper from "../../../../../../components/PageWrapper/PageWrapper";
import { defineMessages, useIntl } from "react-intl";
import GroupNamePopoverMenu from "../../../Classroom/GroupNamePopoverMenu/GroupNamePopoverMenu";
import TabTitle from "../../../../../../components/TabTitle/TabTitle";
import { useDashboardRouter } from "../../../routing";

import { useFeatureFlag } from "@evidenceb/athena-common/modules/FeatureFlags";
import { Button } from "@evidenceb/athena-common/design-system/Button";

const GroupDetails = () => {
    const { groupId } = useParams<{ groupId: string }>();
    const { data: group } = useGroup(groupId);
    const history = useHistory();
    const intl = useIntl();
    const { editGroup: getEditGroupUrl } = useDashboardRouter();
    const groupManagementFlag = useFeatureFlag("groupManagement");

    if (!group) return <LegacyLoader />;

    return (
        <PageWrapper>
            <TabTitle title={group.name} />
            <StudentCollectionDetails
                type="group"
                collection={group}
                title={
                    <div className="student-collection-details__header--group">
                        <h1>{group.name}</h1>
                        <GroupNamePopoverMenu
                            label={intl.formatMessage({
                                id: "dashboard-settings",
                                defaultMessage: "Settings",
                            })}
                            onAction={() =>
                                history.push(getEditGroupUrl(group.id))
                            }
                        >
                            <GroupNamePopoverMenu.Item>
                                {intl.formatMessage({
                                    id: "classList-renameGroup",
                                    defaultMessage: "Rename group",
                                })}
                            </GroupNamePopoverMenu.Item>
                        </GroupNamePopoverMenu>
                    </div>
                }
                studentsListOptions={
                    groupManagementFlag ? (
                        <Button
                            type="button"
                            label={intl.formatMessage(
                                messages.modifyGroupMembers
                            )}
                            color="var(--element-teacher-default)"
                            asRouterLink={{
                                to: getEditGroupUrl(group.id),
                            }}
                        />
                    ) : undefined
                }
            />
        </PageWrapper>
    );
};
export default GroupDetails;

const messages = defineMessages({
    modifyGroupMembers: {
        id: "group-details-addStudents",
        defaultMessage: "Modify group members",
    },
});
